import { useEffect, useRef, useState } from "react";

/**
 * localStorage-backed state. Lazy-initializes from storage, writes on
 * change, and survives StrictMode double-invocation. Falls back to
 * in-memory map when storage throws (private mode / disabled).
 */
export default function useLocalStorage(key, initialValue) {
  const [value, setValue] = useState(() => {
    try {
      const raw = window.localStorage.getItem(key);
      if (raw !== null) return JSON.parse(raw);
    } catch {
      /* storage unavailable */
    }
    return initialValue;
  });

  const valueRef = useRef(value);
  valueRef.current = value;

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* storage unavailable */
    }
  }, [key, value]);

  return [value, setValue];
}
